import { createRecipe } from './runtime.js';

const fieldConfig = {"name":"field","defaultVariants":{"fullWidth":false},"variantMap":{"fullWidth":["true"]}}

export const field = /* @__PURE__ */ createRecipe(fieldConfig)